export default "__VITE_ASSET__B5NzYNJttwgbrPdaqgh8UQ__";